export default __webpack_public_path__ + "static/partners-page-hero-781d888faf82bdd2efdeb2ce8d344e55.png";